import { ApiTypes } from '@mode/shared/contract-common';

/**
 * @class Resource An application/vnd.mode+json client for AngularJS
 * @constructor
 * @param {Object} [properties]  Initialize the record with these property values.
 * @param {Object} [options]
 */
export class Resource implements ApiTypes.ModeResource {
  _links: any;
  _forms: any;
  _embedded: any;

  constructor(properties: any, options = null) {
    // eslint-disable-next-line prefer-spread, prefer-rest-params
    this.$initialize.apply(this, arguments as any);
  }

  /**
   * Constructor logic
   * (which is called by the autogenerated constructor via ApiTypes.ModeResource.extend)
   * @param {Object} [representation]  Initialize the resource with this representation.
   * @param {Object} [options]
   */
  $initialize(representation: any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this as any;

    if (representation) {
      for (const prop in representation) {
        if (representation.hasOwnProperty(prop)) {
          const value = representation[prop];
          if (prop !== '_links' && prop !== '_forms' && prop !== '_embedded') {
            self[prop] = value;
          }
        }
      }
    }

    if (representation['_links']) {
      const links = {} as { [key: string]: string };
      for (const rel in representation['_links']) {
        if (representation['_links'].hasOwnProperty(rel)) {
          const value = representation['_links'][rel];
          links[rel] = self.createLink(value);
        }
      }
      this['_links'] = links;
    } else {
      this['_links'] = {};
    }

    if (representation['_forms']) {
      const forms = {} as { [key: string]: string };
      for (const rel in representation['_forms']) {
        if (representation['_forms'].hasOwnProperty(rel)) {
          const value = representation['_forms'][rel];
          forms[rel] = self.createForm(value);
        }
      }
      this['_forms'] = forms;
    } else {
      this['_forms'] = {};
    }

    if (representation['_embedded']) {
      const embedded = {} as { [key: string]: Resource[] | Resource };
      for (const rel in representation['_embedded']) {
        if (representation['_embedded'].hasOwnProperty(rel)) {
          const value = representation['_embedded'][rel];
          if (Array.isArray(value) || value instanceof Array) {
            const resources = [];
            for (let i = 0; i < value.length; i++) {
              resources.push(new Resource(value[i]));
            }
            embedded[rel] = resources;
          } else {
            embedded[rel] = new Resource(value);
          }
        }
      }

      this['_embedded'] = embedded;
    } else {
      this['_embedded'] = {};
    }
  }

  setLink(name: string, link: any) {
    this['_links'][name] = this.createLink({ href: link });
  }

  createLink(value: any): string {
    return value;
  }

  links(rel: string) {
    return this['_links'][rel];
  }

  hasLink(rel: string) {
    return typeof this.links(rel) !== 'undefined' && this.links(rel) !== null;
  }

  createForm(value: string): string {
    return value;
  }

  forms(rel: string) {
    return this['_forms'][rel];
  }

  hasForm(rel: string) {
    return typeof this.forms(rel) !== 'undefined' && this.forms(rel) !== null;
  }

  embedded(rel: string) {
    return this['_embedded'][rel];
  }

  hasEmbedded(rel: string) {
    return typeof this.embedded(rel) !== 'undefined' && this.embedded(rel) !== null;
  }

  generate<T extends ApiTypes.ModeResource>(representation: T): T {
    return new Resource(representation) as any;
  }
}
